/**
 * Alias for `ParentNode.querySelector` whose generic extends `HTMLElement`.
 *
 * Throws an error if the element is not found.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/querySelector
 * @throws {Error} If the element is not found.
 */
export const query = (selector, parent = document) => {
    const element = parent.querySelector(selector);
    if (!element) {
        throw new Error(`Element not found: '${selector}'`);
    }
    return element;
};
/**
 * Alias for `ParentNode.querySelectorAll` whose generic extends `HTMLElement`.
 *
 * Returns an array instead of a static NodeList.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/querySelectorAll
 */
export const queryAll = (selector, parent = document) => Array.from(parent.querySelectorAll(selector));
